const integerFormatter = new Intl.NumberFormat("id-ID", {
  maximumFractionDigits: 0,
});

const largeOperationalFormatter = new Intl.NumberFormat("id-ID", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

const mediumOperationalFormatter = new Intl.NumberFormat("id-ID", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const smallOperationalFormatter = new Intl.NumberFormat("id-ID", {
  minimumSignificantDigits: 1,
  maximumSignificantDigits: 3,
});

const detailFormatter = new Intl.NumberFormat("id-ID", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
});

function toFiniteNumber(value) {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return null;
  }

  const numeric = Number(value);

  return Number.isFinite(numeric)
    ? numeric
    : null;
}

/**
 * Digunakan untuk total, summary, Fleet Order, peta, dashboard,
 * kapasitas, dan tampilan operasional ringkas.
 *
 * Rule:
 * - integer: tanpa desimal
 * - >= 100: maksimal 1 desimal
 * - >= 1: maksimal 2 desimal
 * - < 1: maksimal 3 angka signifikan
 */
export function formatOperationalNumber(
  value,
  fallback = "—",
) {
  const numeric = toFiniteNumber(value);

  if (numeric === null) {
    return fallback;
  }

  if (numeric === 0 || Number.isInteger(numeric)) {
    return integerFormatter.format(numeric);
  }

  const absolute = Math.abs(numeric);

  if (absolute >= 100) {
    return largeOperationalFormatter.format(numeric);
  }

  if (absolute >= 1) {
    return mediumOperationalFormatter.format(numeric);
  }

  return smallOperationalFormatter.format(numeric);
}

/**
 * Digunakan untuk data detail:
 * SKU Logistics, item, dan validasi kalkulasi.
 *
 * Nilai nonnol yang lebih kecil dari 0,0001 tidak ditampilkan
 * sebagai nol.
 */
export function formatDetailNumber(
  value,
  fallback = "—",
) {
  const numeric = toFiniteNumber(value);

  if (numeric === null) {
    return fallback;
  }

  if (numeric === 0 || Number.isInteger(numeric)) {
    return integerFormatter.format(numeric);
  }

  if (Math.abs(numeric) < 0.0001) {
    return numeric < 0
      ? "> -0,0001"
      : "< 0,0001";
  }

  return detailFormatter.format(numeric);
}

export function formatWeight(value) {
  const formatted = formatOperationalNumber(value);

  return formatted === "—"
    ? formatted
    : `${formatted} kg`;
}

export function formatVolume(value) {
  const formatted = formatOperationalNumber(value);

  return formatted === "—"
    ? formatted
    : `${formatted} m³`;
}

export function formatDetailWeight(value) {
  const formatted = formatDetailNumber(value);

  return formatted === "—"
    ? formatted
    : `${formatted} kg`;
}

export function formatDetailVolume(value) {
  const formatted = formatDetailNumber(value);

  return formatted === "—"
    ? formatted
    : `${formatted} m³`;
}